export const currentLocations = [
  'Mumbai, Maharashtra',
  'Bangalore, Karnataka',
  'Hyderabad, Telangana',
  'Chennai, Tamil Nadu',
  'Pune, Maharashtra',
  'Delhi, Delhi',
  'Noida, Uttar Pradesh',
  'Gurugram, Haryana',
  'Kolkata, West Bengal',
  'Ahmedabad, Gujarat',
  'Other',
];

export const primarySkillOptions = [
  'JavaScript',
  'React',
  'Node.js',
  'Java',
  'Python',
  'Angular',
  'Vue.js',
  'C#',
  'PHP',
  'Data Science',
  'DevOps',
  'Salesforce',
  'AWS',
  'Azure',
  'Google Cloud',
];

export const secondarySkillOptions = [
  'Docker',
  'Kubernetes',
  'SQL',
  'NoSQL',
  'GraphQL',
  'REST APIs',
  'TypeScript',
  'Microservices',
  'CI/CD',
  'Machine Learning',
  'UI/UX',
  'SEO',
  'Testing',
  'Blockchain',
];

export const workTypeOptions = [
  'Full-time',
  'Part-time',
  'Contract',
  'Freelance',
  'Internship',
  'Project-based',
];

export const roleOptions = [
  'Software Engineer',
  '.NET Developer',
  'Java Developer',
  'Full Stack Developer',
  'Frontend Developer',
  'Backend Developer',
  'Java Backend Developer',
  'Python Developer',
  'MERN Stack Developer',
  'MEAN Stack Developer',
  'Data Engineer',
  'Data Scientist',
  'DevOps Engineer',
  'Cloud Architect',
  'QA Engineer',
  'Test Automation Engineer',
  'Technical Lead',
  'Solutions Architect',
  'Security Engineer',
  'Systems Administrator',
  'Network Engineer',
  'Mobile Developer',
  'UX/UI Designer',
  'Product Manager',
  'Business Analyst',
  'Database Administrator',
  'Scrum Master',
  'Other',
];

export const feedbackStatusOptions = [
  'Ready to Pitch',
  'No feedback',
  'Final Round',
  'First Round',
  'Hold',
  'HR Final Round',
  'HR Round',
  'Joined',
  'Managerial Round',
  'Not Interested',
  'Offer Accepted',
  'Offer Extended',
  'Pending for Review',
  'Rejected',
  'Second Round',
  'Selected',
  'Shortlisted',
  'Technical Round',
  'Third Round',
];

// Source Options - Common recruitment sources
export const sourceOptions = [
  'LinkedIn',
  'Indeed',
  'Naukri',
  'Internal Referral',
  'Job Portal',
  'Campus Recruitment',
  'Headhunter',
  'Direct Application',
  'Agency',
  'Social Media',
  'Other',
];

// COMMENTED OUT - Notice Period filter disabled
// Notice Period Options - Common notice periods
/*
export const noticePeriodOptions = [
  'Immediate',
  '15 Days',
  '30 Days',
  '45 Days',
  '60 Days',
  '90 Days',
  '3 Months',
  '6 Months',
  'Not specified',
];
*/
